import { css } from 'linaria';
import { variantItemWrapActive } from 'common/components/product-variants/variant-item.styles';

export const carouselItem = css`
  margin-right: var(--space-100);

  &:hover {
    background-color: inherit;
  }
`;
export const carouselContainer = css`
  padding: var(--space-100) 0;

  &::after {
    min-width: 0;
    margin-left: 0;
  }
`;

export const imageOfPuncturePoint = css`
  opacity: 0.2;
`;

export const variantItem = css`
  @media (hover: hover) {
    &:hover:not(.${variantItemWrapActive}) {
      border-color: var(--control-hover-secondary);
    }
  }
`;
